const fbq = action => window.etp.analytics?.fbq('track', action);

export { fbq };
